export default "/assets/b7c80cc05cd38adf1e5571f6563276ab.png";